import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { InspectionRoutingModule } from './inspection-routing.module';
import { RaiseInspectionComponent } from './components/raise-inspection/raise-inspection.component';
import { InspectionsOverviewComponent } from './components/inspections-overview/inspections-overview.component';
import { InspectionService } from './Services/inspection.service';
import { InspectionConstantsService } from './Services/inspection-constants.service';

@NgModule({
  imports: [
    CommonModule,
    InspectionRoutingModule,
    SharedModule
  ],
  declarations:
  [
    RaiseInspectionComponent,
    InspectionsOverviewComponent
  ],
  providers: [
    InspectionService,
    InspectionConstantsService
  ]
})
export class InspectionModule { }
